export default {
  toggleDrawer(state) {
    state.showDrawer = !state.showDrawer;
  },

  toggleNotification(state, payload) {
    state.notificationOpen = payload;
  },
}
